import React from 'react';
import { X, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  type = 'default', // 'default', 'warning', 'error', 'success'
  showCloseButton = true,
  actions = null
}) => {
  if (!isOpen) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'warning':
        return {
          iconColor: '#f59e0b',
          borderColor: '#fbbf24',
          backgroundColor: '#fffbeb'
        };
      case 'error':
        return {
          iconColor: '#ef4444',
          borderColor: '#f87171',
          backgroundColor: '#fef2f2'
        };
      case 'success':
        return {
          iconColor: '#10b981',
          borderColor: '#34d399',
          backgroundColor: '#f0fdf4'
        };
      default:
        return {
          iconColor: '#6b7280',
          borderColor: '#d1d5db',
          backgroundColor: '#ffffff'
        };
    }
  };

  const typeStyles = getTypeStyles();

  const renderTypeIcon = () => {
    switch (type) {
      case 'warning':
        return <AlertTriangle size={24} color={typeStyles.iconColor} />;
      case 'error':
        return <XCircle size={24} color={typeStyles.iconColor} />;
      case 'success':
        return <CheckCircle size={24} color={typeStyles.iconColor} />;
      default:
        return null;
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '16px'
      }}
      onClick={handleBackdropClick}
    >
      <div 
        style={{
          backgroundColor: typeStyles.backgroundColor,
          borderRadius: '12px',
          border: `2px solid ${typeStyles.borderColor}`,
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          maxWidth: '500px',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'auto',
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          padding: '24px 24px 16px 24px',
          borderBottom: `1px solid ${typeStyles.borderColor}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {renderTypeIcon()}
            <h3 style={{
              margin: 0,
              fontSize: '18px',
              fontWeight: '600',
              color: '#1f2937'
            }}>
              {title}
            </h3>
          </div>
          {showCloseButton && (
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#f3f4f6'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <X size={20} color="#6b7280" />
            </button>
          )}
        </div>

        {/* Content */}
        <div style={{
          padding: '24px',
          color: '#374151',
          lineHeight: '1.6'
        }}>
          {children}
        </div>

        {/* Actions */}
        {actions && (
          <div style={{
            padding: '16px 24px 24px 24px',
            borderTop: `1px solid ${typeStyles.borderColor}`,
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-end'
          }}>
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
